<template>
    <div style="background-color: #F9F9F9;">
        <div style="padding: 16px 10px; background-color: #fff; display: flex; align-items: center;">
            <div>
                <img src="./../assets/home/banner.png" alt="" srcset=""
                    style="width: 90px; height: 90px; border-radius: 12px;">
            </div>
            <div style="flex: 1; margin-left: 12px;">
                <div style="display: flex; align-items: center;">
                    <div style="font-size: 24px; letter-spacing: 2px; font-weight: 800; flex: 1; color: #3E4F7A;">{{
                        name }}
                    </div>
                    <div
                        style="color: #43974E; background-color: #E8F5ED; padding: 4px 12px; font-size: 14px; border: 1px solid #43974E; border-radius: 30px;">
                        ● 正在營業</div>
                </div>
                <div style="margin-top: 6px; display: flex;">
                    <div v-for="(item, index) in dashboards" :key="index" style="padding: 0 24px 0 0;">
                        <div style="font-size: 14px; color: grey;">{{ item.label }}</div>
                        <div style="color: #3E4F7A;">
                            <div style="font-weight: 800; font-size: 16px;" v-if="index <= 2">{{ item.value }}</div>
                            <div v-else style="font-size: 14px;">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="marquee-container" v-for="(item, index) in revolvingLanternList" :key="index">
            <div class="marquee-icon">
                <img src="../assets/guangbo.png" alt="">
            </div>
            <div class="marquee-content-wrapper">
                <div class="marquee-content">
                    <span style="color: rgb(62, 79, 122);">{{ item.content }}</span>
                </div>
            </div>
        </div>

        <div style="padding: 0 10px;" v-if="selTopMenuIndex == 'shop'">
            <el-row :gutter="10" v-if="advertiseList">
                <div style="">
                    <div v-for="(item, index) in advertiseList" :key="index" style="margin-top: 10px;">
                        <el-col :span="12">
                            <img :src="`/api/file/download/${item.image}`"
                                style="width: 100%; border-radius: 5px; display: block;">
                        </el-col>
                    </div>
                </div>
            </el-row>
        </div>

        <div
            style="padding: 10px; background-color: #fff; margin-top: 12px; border-bottom: 1px solid #F9F9F9; padding-bottom: 4px;">
            <div style="display: flex; padding: 6px; align-items: center; align-items: center;">
                <div v-for="(item, index) in topMenu" :key="index"
                    style="font-size: 16px; color: grey; margin-right: 36px;" @click="changeTopMenu(item.value)">
                    <!-- <img v-if="item.value === 'diy'" src="../assets/diy.png" alt="" style="width: 90px; height: auto;"> -->
                    <span :class="item.value === selTopMenuIndex ? 'topMenuSelected' : ''">{{ item.label
                    }}</span>
                </div>
            </div>
        </div>
        <div style="padding-top: 8px; background-color: #fff;">
            <ShopPage v-if="selTopMenuIndex === 'shop'"></ShopPage>
            <AboutPage v-if="selTopMenuIndex === 'about'"></AboutPage>
            <MyPage v-if="selTopMenuIndex === 'my'"></MyPage>
            <LoginPage v-if="selTopMenuIndex === 'login'"></LoginPage>
        </div>
        <FloatingButton @click="handleButtonClick()" />

    </div>
</template>

<script>
import ShopPage from "@/components/ShopPage.vue"
import AboutPage from "@/components/AboutPage.vue"
import LoginPage from "@/components/LoginPage.vue"
import MyPage from "@/components/MyPage.vue"
import FloatingButton from '@/components/FloatingButton.vue';

export default {
    name: 'HomePage',
    components: {
        ShopPage,
        AboutPage,
        MyPage,
        LoginPage,
        FloatingButton
    },
    data() {
        return {
            name: "",
            dashboards: [
                {
                    label: "顧客",
                    value: ""
                },
                {
                    label: "項目",
                    value: ""
                },
                {
                    label: "訂單",
                    value: ""
                },
                {
                    label: "服務水平",
                    value: ""
                }
            ],
            topMenu: [{
                label: '商品',
                value: "shop"
            }, {
                label: '🎉 定製 🎉',
                value: "diy"
            }
                // , {
                //     label: '關於',
                //     value: "about"
                // }
            ],
            selTopMenuIndex: 'shop',
            revolvingLanternList: [],
            advertiseList: [],
            keyAddress: '',
            set: {}
        }
    },
    mounted() {
        if (this.checkIsLogin()) {
            this.topMenu.push({
                label: '我的',
                value: "my"
            })
        } else {
            this.topMenu.push({
                label: '登錄',
                value: "login"
            })
        }

        // this.GETTotal()
        // this.GETCommodityTotal()

        // 獲取跑馬燈
        this.getRevolvingLanternList()

        // 獲取廣告位
        this.getAdvertiseList()

        // 獲取基礎設置項目
        this.getBasicSettings()

        // 恢復菜單序列
        this.selTopMenuIndex = localStorage.getItem("selTopMenuIndex") || "shop"

        // 獲取代理邀請碼
        this.GetProxyInvite()

        // 獲取商品列表
        this.getProject()

    },
    methods: {
        getProject() {
            this.$axios.get(`/api/project/list`).then(res => {
                this.dashboards[1].value = res.data.data.total
            })
        },
        GetProxyInvite() {
            var code = this.$route.query.share

            localStorage.setItem('PROXY_FROM', code)
        },
        getBasicSettings() {
            this.$axios.get("/api/set/get").then(res => {
                let d = res.data.data
                this.set = d

                this.dashboards[0].value = d.customer
                this.dashboards[2].value = d.order
                this.dashboards[3].value = `超過${d.avg}%的商家`

                this.name = d.name
            })
        },
        getRevolvingLanternList() {
            this.$axios.get("/api/revolvingLantern/list").then(res => {
                this.revolvingLanternList = res.data.data.items
            })
        },
        getAdvertiseList() {
            this.$axios.get("/api/advertise/list").then(res => {
                this.advertiseList = res.data.data.items
            })
        },
        handleButtonClick() {
            // 在這裏添加點擊處理邏輯
            const a = document.createElement('a');
            console.log(`https://t.me/${this.set.tg_group}`)
            a.href = encodeURI(`https://t.me/${this.set.tg_group}`);

            a.target = '_blank';
            a.rel = 'noopener noreferrer'; // 安全優化

            // 兼容現代瀏覽器和IE的點擊觸發
            if (document.createEvent) {
                const event = document.createEvent('MouseEvents');
                event.initEvent('click', true, true);
                a.dispatchEvent(event);
            } else {
                a.click();
            }
        },
        checkIsLogin() {
            var name = "CAS-ID"
            const cookies = document.cookie.split(';');
            for (const cookie of cookies) {
                const [cookieName] = cookie.trim().split('=');
                if (cookieName === name) {
                    return true;
                }
            }
            return false
        },
        changeTopMenu(e) {
            console.log(e)
            switch (e) {
                case 'diy': {
                    console.log("222")
                    // 判斷是否登錄
                    if (!this.checkIsLogin()) {
                        this.selTopMenuIndex = 'login'
                        localStorage.setItem("selTopMenuIndex", 'login')
                        return
                    }

                    const url = this.$router.resolve({ path: '/meeting' }).href;
                    window.open(url, '_blank');
                    break
                }
                default: {
                    this.selTopMenuIndex = e
                    localStorage.setItem("selTopMenuIndex", e)
                }
            }

        },
        // 獲取基礎信息設置
        // GETTotal() {
        //     this.$axios.get("/api/map/list").then(res => {
        //         this.dashboards[0].value = res.data.data.items[0].value
        //         this.dashboards[2].value = res.data.data.items[1].value
        //     })
        // },
        // GETCommodityTotal() {
        //     this.$axios.get("/api/index/getTotal").then(res => {
        //         this.dashboards[1].value = res.data.items.commodityTotal
        //     })
        // }
    }
}
</script>

<style>
* {
    padding: 0;
    margin: 0;
}

.topMenuSelected {
    color: #3E4F7A;
    font-size: 20px;
    font-weight: 800;
    /* border-bottom: 4px solid #2962F1;
    padding-bottom: 4px; */
}

@font-face {
    font-family: 'PingFang';
    src: url('@/assets/fonts/PingFang Medium_downcc.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
}

body {
    font-family: 'MyFont', sans-serif;
}
</style>

<style>
.marquee-container {
    background-color: rgb(255, 255, 255);
    margin: 10px 10px 0 10px;
    border-radius: 5px;
    padding: 10px 10px;
    display: flex;
    align-items: center;
}

.marquee-icon {
    display: flex;
    align-items: center;
    z-index: 10;
    background-color: rgb(255, 255, 255);
    padding: 0px 10px;
}

.marquee-icon img {
    width: 20px;
    height: 20px;
    background-color: rgb(255, 255, 255);
}

.marquee-content-wrapper {
    overflow: hidden;
    width: 100%;
}

.marquee-content {
    display: inline-block;
    white-space: nowrap;
    padding-left: 100%;
    /* 關鍵：確保從最右側開始 */
    animation: marquee 15s linear infinite;
}

.marquee-content:hover {
    animation-play-state: paused;
}

/* 關鍵：動畫從0到-200%，確保完整滾出 */
@keyframes marquee {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-100%);
    }
}
</style>